@use '@design/design-tokens/typography/typography' as *;

.resetButton {
  @include typography-v2-title-sm;
  font-weight: normal;
  color: var(--text-primary);

  [data-button-label] svg {
    fill: var(--text-primary);
  }
}
